module.exports = __webpack_public_path__ + "static/media/incompliance_long.dbab3825.png";